import { createAsyncThunk } from "@reduxjs/toolkit";
import { createContractApi } from "../../../api";
import { getProblemDetails } from "./helpers";
import type { LoginThunkConfig } from "./types";

interface ChangeContractPasswordArgs {
  accessToken: string;
  currentPassword: string;
  newPassword: string;
}

/**
 * 契約パスワードを変更します。
 */
export const changeContractPassword = createAsyncThunk<
  void,
  ChangeContractPasswordArgs,
  LoginThunkConfig
>(
  "login/changeContractPassword",
  async (arg, thunk) => {
    try {
      await createContractApi(arg.accessToken).changeContractPassword({
        currentPassword: arg.currentPassword,
        newPassword: arg.newPassword,
      });
    } catch (error) {
      const problem = getProblemDetails(error);
      if (problem) {
        return thunk.rejectWithValue(problem);
      }
      throw error;
    }
  }
);

interface ResetContractPasswordArgs {
  contractId: string;
  passwordResetToken: string;
  newPassword: string;
}

/**
 * 契約パスワードをリセットします。
 */
export const resetContractPassword = createAsyncThunk<
  void,
  ResetContractPasswordArgs,
  LoginThunkConfig
>(
  "login/resetContractPassword",
  async (arg, thunk) => {
    try {
      await createContractApi().resetContractPassword({
        contractId: arg.contractId,
        token: arg.passwordResetToken,
        newPassword: arg.newPassword,
      });
    } catch (error) {
      const problem = getProblemDetails(error);
      if (problem) {
        return thunk.rejectWithValue(problem);
      }
      throw error;
    }
  }
);

interface ForgotContractIdArgs {
  email: string;
}

/**
 * 契約IDを忘れた場合に、契約IDをメールで送信します。
 */
export const forgotContractId = createAsyncThunk<
  void,
  ForgotContractIdArgs,
  LoginThunkConfig
>(
  "login/forgotContractId",
  async (arg, thunk) => {
    try {
      await createContractApi().forgotContractId({
        email: arg.email,
      });
    } catch (error) {
      const problem = getProblemDetails(error);
      if (problem) {
        return thunk.rejectWithValue(problem);
      }
      throw error;
    }
  }
);

interface ForgotPasswordArgs {
  contractId: string;
  email: string;
}

/**
 * 契約パスワードを忘れた場合に、パスワードリセット用のメールを送信します。
 */
export const forgotPassword = createAsyncThunk<
  void,
  ForgotPasswordArgs,
  LoginThunkConfig
>(
  "login/forgotPassword",
  async (arg, thunk) => {
    try {
      await createContractApi().forgotContractPassword({
        contractId: arg.contractId,
        email: arg.email,
      });
    } catch (error) {
      const problem = getProblemDetails(error);
      if (problem) {
        return thunk.rejectWithValue(problem);
      }
      throw error;
    }
  }
);
